"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidationError = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ValidationError, _Component);

  function ValidationError() {
    (0, _classCallCheck3.default)(this, ValidationError);
    return (0, _possibleConstructorReturn3.default)(this, (ValidationError.__proto__ || (0, _getPrototypeOf2.default)(ValidationError)).apply(this, arguments));
  }

  (0, _createClass3.default)(ValidationError, [{
    key: "render",
    value: function render() {
      var fieldProps = this.props.fieldProps;

      if (fieldProps.touched && fieldProps.error) {
        return _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "span",
            { className: "validation-error" },
            fieldProps.error
          )
        );
      } else {
        return null;
      }
    }
  }]);
  return ValidationError;
}(_react.Component), _class.propTypes = {
  fieldProps: _react.PropTypes.object.isRequired
}, _temp);
exports.default = ValidationError;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/form/ValidationError.js
 ** module id = 134
 ** module chunks = 0
 **/